module.exports = __webpack_public_path__ + "img/main-logo.eafe62d0.png";